import { useQuery } from '@tanstack/react-query';
import { supabase } from '@shared/lib/supabase/client';
import { useAuth } from '@shared/features/auth/context/AuthContext';
import type { Database } from '@shared/types/database';

type UserProfile = Database['public']['Tables']['gebruiker_profielen']['Row'];

export function useUserProfile() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['userProfile', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;

      const { data, error } = await supabase
        .from('gebruiker_profielen')
        .select('*')
        .eq('id', user.id)
        .single();

      if (error) {
        console.error('Error fetching user profile:', error);
        return null;
      }

      return data as UserProfile;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}